import { ElMessage, ElMessageBox } from "element-plus";
import { reactive, ref } from "vue";
import { queryAllotTableNew, handleProcessApi, deleteCheckById } from "@/api/allot";
import { postDownload } from "@/utils";

export default function useAllotTable() {
  // 搜索条件ref
  const searchRef = ref(null);

  // 搜索条件
  const searchData = reactive({
    number: null,
    outbound: null,
    inbound: null,
    remark: null,
    approvalStatus: null,
    allocateUserText: '',
  });

  // 表格列配置
  const columns = ref([
    // {
    //   label: "单号",
    //   prop: "number",
    // },
    // {
    //   label: "出库仓库",
    //   prop: "outBoundWarehouse.name",
    // },
    // {
    //   label: "入库仓库",
    //   prop: "inBoundWarehouse.name",
    // },
    {
      label: "物料名称",
      prop: "materialNameList",
      width: 200,
    },
    {
      label: "备注",
      prop: "remark",
      width: 200,
    },
    {
      label: "调拨时间",
      prop: "allocateTime",
    },
    {
      label: "创建人",
      prop: "allocateUserText",
    },
    {
      label: "审核状态",
      prop: "approvalStatus",
    },
  ]);

  // 表格loading
  const tableLoading = ref(true);

  // 表格数据
  const tableData = ref([]);

  // 分页参数
  const pages = reactive({
    page: 1,
    limit: 10,
    total: 0,
  });

  // 获取数据
  const getList = () => {
    tableLoading.value = true;
    queryAllotTableNew({
      ...searchData,
      page: pages.page,
      descs: 'create_time'
    })
      .then((res) => {
        tableData.value = res.data.records;
        pages.total = res.data.total;
      })
      .finally(() => {
        tableLoading.value = false;
      });
  };

  // 重置
  const handleReset = () => {
    searchRef.value?.resetFields();
    getList();
  };

  // 范围时间选择器
  const dateRangeSelector = reactive({
    checkDate: null,
    createDate: null,
  });

  // 创建时间变化
  const createDateChange = () => {
    searchData.startTime = dateRangeSelector.createDate?.[0];
    searchData.endTime = dateRangeSelector.createDate?.[1];
  };


  // 导出
  const handleExport = () => {
    ElMessageBox.confirm("确定导出调拨数据吗？", "导出", {
      confirmButtonText: "导出",
      cancelButtonText: "取消",
      type: "success",
    })
      .then(() => {
        postDownload("/allocate/export", {}, "调拨记录.xlsx");
      })
      .catch(() => {
        ElMessage.info("已取消");
      });
  };

  // 提交审核
  const handleProcess = (id) => {
    ElMessageBox.confirm("确定要提交审核?", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "success",
    })
      .then(() => {
        handleProcessApi(id).then((res) => {
          if (res.code == "2000") {
            ElMessage.success("操作成功");
            getList();
          }
        })
      })
      .catch(() => {
        ElMessage.info("已取消");
      })
  };

  // 删除
  const handleDelete = (ids) => {
    ElMessageBox.confirm("确定删除所选数据吗?", "删除", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "error",
    })
      .then(() => {
        console.log('=====id', ids);
        deleteCheckById(ids).then((res) => {
          if (res.code == "2000") {
            ElMessage.success("操作成功");
            getList();
          }
        });
      })
      .catch(() => {
        ElMessage.info("已取消");
      });
  };


  return {
    searchRef,
    searchData,
    columns,
    tableLoading,
    tableData,
    pages,
    getList,
    handleReset,
    handleExport,
    dateRangeSelector,
    createDateChange,
    handleProcess,
    handleDelete
  };
}
